import React from "react";
import { BusinessAccountResponse } from "../../../../../datatypes/businessaccounts/BusinessAccount";
import { connect } from "../../../../../utils/storeConnect";
import { BusinessAccountStore } from "../../../../../stores/businessaccounts/BusinessAccountStore";
import { AccountFlyoutProfile } from "./AccountFlyoutProfile";
import AccountFlyoutDropdown from "./AccountFlyoutDropdown";

type Props = {
    businessAccountData: BusinessAccountResponse | undefined | null;
    tierLevel: string | undefined;
};

type State = {
    isMenuVisible: boolean;
};

class AccountFlyoutWrapper extends React.Component<Props, State> {
    accountFlyoutDropdownWrapper: React.RefObject<HTMLDivElement>;

    constructor(props: Props) {
        super(props);
        this.state = { isMenuVisible: false };
        this.accountFlyoutDropdownWrapper = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside.bind(this), false);
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside.bind(this), false);
    }

    renderAccountProfile(businessAccountData: BusinessAccountResponse) {
        return (
            <AccountFlyoutProfile
                setMenuVisible={this.setMenuVisibleState.bind(this)}
                businessAccount={businessAccountData}
                isMenuVisible={this.state.isMenuVisible}
            />
        );
    }

    setMenuVisibleState(isMenuVisible: boolean) {
        this.setState({ isMenuVisible: isMenuVisible });
    }

    handleClickOutside(event: MouseEvent) {
        if (
            this.accountFlyoutDropdownWrapper &&
            !this?.accountFlyoutDropdownWrapper?.current?.contains(event.target as Node) &&
            this.state.isMenuVisible
        ) {
            this.setMenuVisibleState(false);
            window.document.body.classList.remove("disable-scrolling");
        }
    }

    renderMainDropdown() {
        return (
            <React.Fragment>
                {this.props.businessAccountData && (
                    <AccountFlyoutDropdown
                        setIsMenuVisible={this.setMenuVisibleState.bind(this)}
                        businessAccount={this.props.businessAccountData}
                        display={this.state.isMenuVisible}
                        tierLevel={this.props.tierLevel}
                    />
                )}
            </React.Fragment>
        );
    }

    render() {
        return (
            <div className="component-content" ref={this.accountFlyoutDropdownWrapper}>
                {this.props.businessAccountData && this.renderAccountProfile(this.props.businessAccountData)}
                {this.renderMainDropdown()}
            </div>
        );
    }
}

export default connect(
    {
        stores: [
            [
                BusinessAccountStore,
                (store: typeof BusinessAccountStore) => {
                    const businessAccountData = store.getData();
                    return { businessAccountData };
                }
            ]
        ]
    },
    AccountFlyoutWrapper
);
